export default __webpack_public_path__ + "static/media/arrow-narrow.2b0c885d.svg";